// Provenance: repo:tds-reconciliation-portal:frontend/src/shell/workspace.ts (ADR-0005) —
// ids became UUID strings; the entity became the client (ADR-0002).
import { useMatch } from 'react-router'

export interface WorkspaceParams {
  clientId: string
  periodId: string
  base: string
  section: string
}

/** Parse /w/:clientId/:periodId/* from the current location (null outside). */
export function useWorkspaceMatch(): WorkspaceParams | null {
  const match = useMatch('/w/:clientId/:periodId/*')
  if (!match) return null
  const clientId = match.params.clientId ?? ''
  const periodId = match.params.periodId ?? ''
  if (!clientId || !periodId) return null
  return {
    clientId,
    periodId,
    base: `/w/${clientId}/${periodId}`,
    section: match.params['*'] ?? '',
  }
}

// `rememberWorkspace` / `lastWorkspaceBase` lived here in the predecessor and
// stayed deleted: a write-only record of the last-open workspace, surviving
// logout, one wiring change from restoring stale state. Starting clean is the
// point (see sessionReset.ts).
